import api from 'api';

export const TYPE_ITEMS_ASYNC_ACTION_START = 'TYPE_ITEMS_ASYNC_ACTION_START';
export const TYPE_ITEMS_ASYNC_ACTION_ERROR = 'TYPE_ITEMS_ASYNC_ACTION_ERROR';
export const TYPE_ITEMS_ASYNC_UPDATE_ACTION_SUCCESS = 'TYPE_ITEMS_ASYNC_UPDATE_ACTION_SUCCESS';
export const TYPE_ITEMS_PARENT_ID_ASYNC_UPDATE_ACTION_SUCCESS = 'TYPE_ITEMS_PARENT_ID_ASYNC_UPDATE_ACTION_SUCCESS';

function typeItemsAsyncStart() {
  return {
    type: TYPE_ITEMS_ASYNC_ACTION_START,
  };
}

function typeItemsAsyncError(error) {
  return {
    type: TYPE_ITEMS_ASYNC_ACTION_ERROR,
    error,
  };
}

function updateTypeItemsAsyncSuccess(data) {
  return {
    type: TYPE_ITEMS_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
  };
}

function updateTypeItemByParentIdAsyncSuccess(data, typeItemIdParent) {
  return {
    type: TYPE_ITEMS_PARENT_ID_ASYNC_UPDATE_ACTION_SUCCESS,
    data,
    typeItemIdParent,
  };
}

export function getTypeItemsByTypeAsync(type) {
  return (dispatch, getState) => {
    dispatch(typeItemsAsyncStart());
    return api.request(`typeItem/${ type }`, 'get')
    .then((data) => {
      dispatch(updateTypeItemsAsyncSuccess(data));
      return data;
    })
    .catch((err) => {
      dispatch(typeItemsAsyncError('Unable to retreive type items'));
      throw (err);
    });
  };
}

export function getTypeItemsByParentIdAsync(typeItemIdParent) {
  return (dispatch, getState) => {
    dispatch(typeItemsAsyncStart());
    return api.request(`typeItem/parentTypeItem/${ typeItemIdParent }`, 'get')
    .then((data) => {
      dispatch(updateTypeItemByParentIdAsyncSuccess(data, typeItemIdParent));
      return data;
    })
    .catch((err) => {
      dispatch(typeItemsAsyncError('Unable to retreive type items'));
      throw (err);
    });
  };
}

export function getAllChildTypeItems(type) {
  return (dispatch, getState) => {
    dispatch(typeItemsAsyncStart());
    return api.request(`typeItem/childTypeItems/${type}`, 'get')
      .then((data) => {
        dispatch(updateTypeItemsAsyncSuccess(data));
        return data;
      })
      .catch((err) => {
        dispatch(typeItemsAsyncError('Unable to retreive child type items'));
        throw (err);
      });
  };
}

